import axios from '../../config/axios';
import config from '../../config/api';
import { setSnackbar } from './SnackbarAction';
import { fetchProcessorTerminalsForAssignment } from './DropdownActions';


export const getProcessorGroups = (data) => ({
    type: 'GET_PROCESSORGROUPS',
    data
})

export const getFilteredData = (data) => ({
    type: 'FILTER_GROUPS',
    data
})

export const getProcessorTerminalGroups = (data, groupID) =>({
    type: 'GET_PROCESSOR_TERMINAL_GROUPS',
    key: groupID,
    data
})
export const getProcessingGroupHistory = (data, groupID) =>({
    type: 'GET_PROCESSING_GROUP_HISTORY',
    key: groupID,
    data
})


export const fetchProcessorGroups = (merchantID) => {
    return function (dispatch) {
        dispatch(getProcessorGroups([]))
        axios.get(`${config.api.FETCH_URL}/group/getAllGroups/${merchantID}`).then(response => {
            if (response.status === 200) {
                dispatch(getProcessorGroups(response.data));
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const filteredData = (data) => {
    return function (dispatch) {
        dispatch(getFilteredData(data))
    }
}


export const addProcessorGroup = (body) => {
    return function (dispatch) {
        console.log('Fetching Processor Models')
        axios.post(`${config.api.FETCH_URL}/group/addGroup`, body).then(response => {
            if (response.status === 200 || response.status === 201) {
                dispatch(setSnackbar(true, 'success', 'Added Successfully'))
                dispatch(fetchProcessorGroups(body.merchantID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
        })
    }
}

export const addTerminalProcessorGroup = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/group/addProcessorTermGrouping`, body).then(response => {
            if (response.status === 200 || response.status === 201) {
                dispatch(setSnackbar(true, 'success', 'Added Successfully'))
                dispatch(fetchProcessorTerminalGroups(body.processingGroupID))
                dispatch(fetchProcessingGroupHistory(body.processingGroupID))
                dispatch(fetchProcessorTerminalsForAssignment(body.merchantID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
        })
    }
}

export const fetchProcessorTerminalGroups = (groupID) => {
    return function (dispatch) {
        dispatch(getProcessorTerminalGroups([]))
        axios.get(`${config.api.FETCH_URL}/group/getAllProcessingGroups/${groupID}`).then(response => {
            if (response.status === 200 || response.status === 201) {
                dispatch(getProcessorTerminalGroups(response.data, groupID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
        })
    }
}

export const deleteProcessorTerminalGroup = (body) => {
    return function (dispatch) {
        axios.delete(`${config.api.FETCH_URL}/group/deleteProcessorTermGrouping/${body.processorTermID}`).then(response => {
            if (response.status === 200) {
                dispatch(setSnackbar(true, 'success', 'Removed Scucessfully'))
                dispatch(fetchProcessorTerminalGroups(body.groupID))
                dispatch(fetchProcessingGroupHistory(body.groupID))
                dispatch(fetchProcessorTerminalsForAssignment(body.merchantID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
        })
    }
}

export const addProcessingGroupHistory = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/group/addProcessingGroupHistory`, body).then(response => {
            if (response.status === 200 || response.status === 201) {
                dispatch(setSnackbar(true, 'success', 'Added Successfully'))
                dispatch(fetchProcessingGroupHistory(body.processingGroupID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
        })
    }
}

export const fetchProcessingGroupHistory = (groupID) => {
    return function (dispatch) {
        dispatch(getProcessingGroupHistory([]))
        axios.get(`${config.api.FETCH_URL}/group/getProcessingGroupHistory/${groupID}`).then(response => {
            if (response.status === 200 || response.status === 201) {
                dispatch(getProcessingGroupHistory(response.data, groupID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
        })
    }
}

export const deleteProcessingGroupHistory = (body) => {
    return function (dispatch) {
        console.log('Procinng group history Del : ', body)
        axios.delete(`${config.api.FETCH_URL}/group/deleteProcessingGroupHistory/${body.processorTermID}`).then(response => {
            if (response.status === 200) {
                dispatch(setSnackbar(true, 'success', 'Removed Scucessfully'))
                dispatch(fetchProcessingGroupHistory(body.processingGroupID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
        })
    }
}